export const columnConfiguration = [
  {
    columnName: 'Asset Class',
    format: 'string',
    showColumn: true,
    isTotal: true,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: false,
  },
  {
    columnName: '%',
    format: 'string',
    showColumn: true,
    isTotal: false,
    textAlign: 'right',
    isCurrency: true,
    isPercentage: false,
  },
  {
    columnName: '$',
    format: 'string',
    showColumn: true,
    isTotal: true,
    textAlign: 'right',
    isCurrency: false,
    isPercentage: true,
  },
];

export const stratergyColumnConfiguration = [
  {
    columnName: 'Strategy',
    format: 'string',
    showColumn: true,
    isTotal: false,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: false,
  },
  {
    columnName: 'Rate Type',
    format: 'string',
    showColumn: true,
    isTotal: false,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: false,
  },
  {
    columnName: 'Current Rate',
    format: 'string',
    showColumn: true,
    isTotal: false,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: false,
  },
  {
    columnName: 'Account Balance Percentage',
    format: 'string',
    showColumn: true,
    isTotal: false,
    textAlign: 'left',
    isCurrency: true,
    isPercentage: false,
  },
  {
    columnName: 'Account Balance',
    format: 'string',
    showColumn: true,
    isTotal: true,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: true,
  },
];

export const columnWidthArr = ['50%', '22%', '30%'];

export const columnWidthArrStrategy = ['16%', '18%', '14%', '18%', '18%'];

export const childRowsColumnConfig = {
  childRowsParentWidths: ['60%', '20%', '20%'],
  columnWidths: ['60%', '18%', '22%'],
  childTableColumnHeadings: ['Investment Name', 'Units', 'Unit Value'],
  isHyperlink: [true, false, false],
  showChildColumns: [true, true, true],
};

export default {
  grey200: '#D6D6D6',
  iron: '#333333',
  lightGreen: '#EFF4E7',
  darkGreen: '#438300',
  sun90: 'rgba(244, 181, 49, 0.9)',
  sun30: 'rgba(244, 181, 49, 0.3)',
  modalBG: '#474747CC',
  grey: '#FAFAFA',
  darkRed: '#E23D28',
  lightRed: '#F8D3CF',
  darkBlue: '#69869A',
  lightBlue: '#EEF7FC',
  lightGrey: '#EAEAEA',
  darkGrey: '#707070',
  oaBlueTint: '#2B4F8E',
  oaBlue: '#002c77',
  oaIceBlue: '#8BBFF3',
};
